import { render, staticRenderFns } from "./UIInput.vue?vue&type=template&id=088460da&scoped=true"
import script from "./UIInput.vue?vue&type=script&lang=js"
export * from "./UIInput.vue?vue&type=script&lang=js"
import style0 from "./UIInput.vue?vue&type=style&index=0&id=088460da&prod&lang=scss"
import style1 from "./UIInput.vue?vue&type=style&index=1&id=088460da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088460da",
  null
  
)

export default component.exports